import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  MenuItem,
  Autocomplete,
  Tooltip,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CreatableSelect from "react-select/creatable";
import { headingStyle, xBtn } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { textfieldTextBlueBr } from "../../style/PharmacyStyle";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextBlueBorder,
} from "../../style/PatientDetailsStyle";
import { generateMedicine, generateMedicineSalt, ExtractMedicineSummaryV1 } from "../../connections/postApi";
import { getMedicineSaltPharmacySearch } from "../../connections/getApi";
import { normalizeMedicineSalt } from "../../utils/medicineSaltUtils";
import { showToast } from "../../utils/toastUtil";
import {
  autoFocusOffWithOutBorder,
  drTableGreen,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import medicines_icon from "../../assets/medicine.svg";
import UseFetchPackList from "../../helper/UseFetchPackList";
import UseFetchFormType from "../../helper/UseFetchFormType";
import UseGetAllMedicineSaltList from "../../helper/UseGetAllMedicineSaltList";
import { useLocation } from "react-router-dom";
import { updateMedicine } from "../../connections/putApi";
import UseMedicineSaltPharmacy from "../../helper/UseMedicineSaltPharmacy";
import UseFetchMedicineDetailsAdmin from "../../helper/UseFetchMedicineDetailsAdmin";
import useDebounce from "../../hooks/UseDebounce";
import UseFetchSearchSaltsPharmacy from "../../helper/UseFetchSearchSaltsPharmacy";
import { PercentIcon } from "lucide-react";

const EditMedicineBatchShort = ({ onClose, id }) => {
  const { data: packList } = UseFetchPackList();
  const { data: formTypeList } = UseFetchFormType();
  // const { data: medicineSaltList } = UseMedicineSaltPharmacy();

  const [medicineSaltSearchInput, setMedicineSaltSearchInput] = useState("");
  const handleMedicineSaltChange = (value) => {
    // e.preventDefault();
    setMedicineSaltSearchInput(value);
  };
  // const [mediDetails?.payload, setmediDetails?.payload] = useState({});
  const debouncedInputMedicine = useDebounce(medicineSaltSearchInput, 400);

  const { data: medicineSaltList, isLoading: medicineSaltLoading } =
    UseFetchSearchSaltsPharmacy(debouncedInputMedicine, 1, 10);
  const { data: mediDetails } = UseFetchMedicineDetailsAdmin(id);
  const [fieldOptions, setFieldOptions] = useState({
    formTypeList: JSON.parse(localStorage.getItem("formTypeList")) || [],
    medicineSaltList: [],
    packList: JSON.parse(localStorage.getItem("packList")) || [],
  });
  const [showAmount, setShowAmount] = useState(
    !mediDetails?.payload?.flat_price,
  );

  const [formState, setFormState] = useState({
    name: mediDetails?.payload?.name || "",
    company: mediDetails?.payload?.company || "",
    srp: mediDetails?.payload?.srp || "",
    form_type: mediDetails?.payload?.form_type || "",
    flat_price: mediDetails?.payload?.flat_price || "",
    auto_purchase_threshold:
      mediDetails?.payload?.auto_purchase_threshold || "",
    medicine_salt_id: mediDetails?.payload?.medicine_salt?.id || "",
    medicine_salt: mediDetails?.payload?.medicine_salt?.name || "",
    discount: mediDetails?.payload?.discount || "",
    hsn_name: mediDetails?.payload?.hsn_name || "",
  });
  const [errors, setErrors] = useState({});
  const [batches, setBatches] = useState([
    {
      batch_no: "",
      expiry_date: "",
      amount: "",
      purchase_cost: "",
      form_type: "",
      packing: "",
      stock_left: "",
    },
  ]);

  useEffect(() => {
    if (mediDetails?.payload) {
      const hasFlatPrice =
        mediDetails?.flat_price &&
        parseFloat(mediDetails?.payload?.flat_price) > 0;

      setBatches(mediDetails?.payload?.medicine_batches);
      setFormState({
        name: mediDetails?.payload?.name || "",
        company: mediDetails?.payload?.company || "",
        srp: mediDetails?.payload?.srp || "",
        form_type: mediDetails?.payload?.form_type || "",
        flat_price: mediDetails?.payload?.flat_price || "",
        auto_purchase_threshold:
          mediDetails?.payload?.auto_purchase_threshold || "",
        medicine_salt_id: mediDetails?.payload?.medicine_salt?.id || "",
        medicine_salt: mediDetails?.payload?.medicine_salt?.name || "",
        discount: mediDetails?.payload?.discount || "",
        hsn_name: mediDetails?.payload?.hsn_name || "",
      });
    }
    setShowAmount(!mediDetails?.payload?.flat_price);
  }, [mediDetails?.payload]);

  const validateForm = () => {
    const newErrors = {};

    if (!formState.name) newErrors.name = "Medicine name is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };

  // const handleFormChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({
  //     ...prev,
  //     [name]: value,
  //     ...(name === "gst" && {
  //       cgst: value ? (parseFloat(value) / 2).toString() : "",
  //       sgst: value ? (parseFloat(value) / 2).toString() : "",
  //     }),
  //   }));
  //   setErrors((prev) => ({ ...prev, [name]: undefined }));
  // };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "flat_price") {
      const numVal = parseFloat(value);
      setShowAmount(!value || isNaN(numVal) || numVal <= 0);
    }

    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleAddRow = () => {
    setBatches((prev) => [
      ...prev,
      {
        batch_no: "",
        expiry_date: "",
        amount: "",
        purchase_cost: "",
        cgst: "",
        sgst: "",
        packing: "",
        stock_left: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const newBatchArr = [...batches];
    newBatchArr[index] = { ...newBatchArr[index], [field]: value };
    setBatches(newBatchArr);
  };

  useEffect(() => {
    if (packList?.payload?.packing?.length > 0) {
      localStorage.setItem(
        "packList",
        JSON.stringify(packList.payload.packing),
      );
      setFieldOptions((prev) => ({
        ...prev,
        packList: packList.payload.packing,
      }));
    }

    if (formTypeList?.payload?.form_types?.length > 0) {
      localStorage.setItem(
        "formTypeList",
        JSON.stringify(formTypeList?.payload?.form_types),
      );
      setFieldOptions((prev) => ({
        ...prev,
        formTypeList: formTypeList?.payload?.form_types,
      }));
    }

    if (medicineSaltList?.payload?.medicine_salts?.length > 0) {
      const transformedData = medicineSaltList.payload.medicine_salts.map(
        (salt) => [salt.id, salt.name],
      );

      if (mediDetails?.payload?.medicine_salt?.id) {
        const isAlreadyIncluded = transformedData?.some(
          (salt) => salt[0] === mediDetails?.payload?.medicine_salt?.id,
        );

        if (!isAlreadyIncluded) {
          transformedData.push([
            mediDetails?.payload?.medicine_salt?.id,
            mediDetails?.payload?.medicine_salt?.name,
          ]);
        }
      }

      setFieldOptions((prev) => ({
        ...prev,
        medicineSaltList: transformedData,
      }));
    }
  }, [formTypeList, medicineSaltList, packList]);

  const handleDeleteRow = (index) => {
    setBatches(
      (prev) => prev.filter((_, i) => i !== index), // Keep rows that don't match the index
    );
  };

  const handleKeyDown = (e, index, field) => {
    if (field === "batch_no" && e.key === "Enter") {
      if (!batches[index]?.batch_no) {
        setTimeout(() => document.getElementById(`submit`).focus(), 0);
        return;
      }
      setTimeout(
        () => document.getElementById(`expiry_date-${index}`).focus(),
        0,
      );
    }

    if (field === "expiry_date" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`amount-${index}`).focus(), 0);
    }

    if (field === "amount" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`purchase_cost-${index}`).focus(),
        0,
      );
    }

    if (field === "purchase_cost" && e.key === "Enter") {
      setTimeout(() => document.getElementById(`packing-${index}`).focus(), 0);
    }

    if (field === "packing" && e.key === "Enter") {
      setTimeout(
        () => document.getElementById(`stock_left-${index}`).focus(),
        0,
      );
    }

    if (field === "stock_left" && e.key === "Enter") {
      if (batches?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`batch_no-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`batch_no-${index + 1}`).focus(),
          100,
        );
      }
    }
  };

  const [loading, setLoading] = useState(false);
  const [autoFillSaltLoading, setAutoFillSaltLoading] = useState(false);
  const [saltCreating, setSaltCreating] = useState(false);
  const [saltInputValue, setSaltInputValue] = useState("");

  const handleAutoFillSalt = async () => {
    if (!formState.name?.trim()) {
      showToast("Enter medicine name first to auto-fill salt", "ERROR");
      return;
    }
    setAutoFillSaltLoading(true);
    try {
      // Step 1: AI suggestion
      const res = await ExtractMedicineSummaryV1(
        "",
        "medicine_salt",
        "GlobalAiContext",
        null,
        null,
        [formState.name],
      );
      const salts = res?.payload?.summaries?.medicines
        ?.map((m) => m?.salt)
        .filter(Boolean);
      const salt = salts?.join(" + ") || null;
      if (!salt) {
        showToast("Could not determine salt. Please enter manually.", "ERROR");
        return;
      }
      const normalized = normalizeMedicineSalt(salt);

      // Step 2: search if salt already exists
      const searchRes = await getMedicineSaltPharmacySearch(normalized, 1, 5);
      const existing = searchRes?.payload?.medicine_salts || [];
      const match = existing.find(
        (s) => s.name?.toLowerCase().trim() === normalized.toLowerCase().trim(),
      );

      if (match) {
        // Found — auto-select without creating
        setFieldOptions((prev) => ({
          ...prev,
          medicineSaltList: prev.medicineSaltList?.some(([id]) => id === match.id)
            ? prev.medicineSaltList
            : [...(prev.medicineSaltList || []), [match.id, match.name]],
        }));
        setFormState((prev) => ({
          ...prev,
          medicine_salt_id: match.id,
          medicine_salt: match.name,
        }));
        setSaltInputValue("");
        showToast(`Salt "${match.name}" found & selected`, "SUCCESS");
      } else {
        // Not found — create then auto-select
        const result = await generateMedicineSalt({
          medicine_salt: { name: normalized },
          medicines_ids: [],
        });
        if (result?.status?.status === "SUCCESS") {
          const newSalt = result?.payload?.medicine_salt || result?.payload;
          const newId = newSalt?.id || newSalt?.medicine_salt_id || null;
          const newName = newSalt?.name || newSalt?.medicine_salt_name || normalized;
          setFieldOptions((prev) => ({
            ...prev,
            medicineSaltList: [...(prev.medicineSaltList || []), [newId, newName]],
          }));
          setFormState((prev) => ({
            ...prev,
            medicine_salt_id: newId,
            medicine_salt: newName,
          }));
          setSaltInputValue("");
          showToast(result?.status?.message || "Salt created & selected", "SUCCESS");
        } else {
          showToast(result?.status?.message || "Failed to create salt", "ERROR");
        }
      }
    } catch {
      showToast("Failed to auto-fill salt", "ERROR");
    } finally {
      setAutoFillSaltLoading(false);
    }
  };

  const handleCreateSalt = async (inputValue) => {
    const normalized = normalizeMedicineSalt(inputValue);
    setSaltCreating(true);
    try {
      const result = await generateMedicineSalt({
        medicine_salt: { name: normalized },
        medicines_ids: [],
      });
      if (result?.status?.status === "SUCCESS") {
        const newSalt = result?.payload?.medicine_salt || result?.payload;
        const newId = newSalt?.id || newSalt?.medicine_salt_id || null;
        const newName = newSalt?.name || newSalt?.medicine_salt_name || normalized;
        setFieldOptions((prev) => ({
          ...prev,
          medicineSaltList: [...(prev.medicineSaltList || []), [newId, newName]],
        }));
        setFormState((prev) => ({
          ...prev,
          medicine_salt_id: newId,
          medicine_salt: newName,
        }));
        setSaltInputValue("");
        showToast(result?.status?.message || "Salt created successfully", "SUCCESS");
      } else {
        showToast(result?.status?.message || "Failed to create salt", "ERROR");
      }
    } catch {
      showToast("Failed to create salt", "ERROR");
    } finally {
      setSaltCreating(false);
    }
  };

  // If the user typed/pasted a salt name but never clicked "Create" or picked an
  // option, resolve it on submit: reuse an existing match, otherwise create it.
  const resolveTypedSalt = async () => {
    const typed = saltInputValue?.trim();
    if (!typed) return null;
    const normalized = normalizeMedicineSalt(typed);
    try {
      const searchRes = await getMedicineSaltPharmacySearch(normalized, 1, 5);
      const existing = searchRes?.payload?.medicine_salts || [];
      const match = existing.find(
        (s) => s.name?.toLowerCase().trim() === normalized.toLowerCase().trim(),
      );
      if (match) return { id: match.id, name: match.name };

      const result = await generateMedicineSalt({
        medicine_salt: { name: normalized },
        medicines_ids: [],
      });
      if (result?.status?.status === "SUCCESS") {
        const newSalt = result?.payload?.medicine_salt || result?.payload;
        return {
          id: newSalt?.id || newSalt?.medicine_salt_id || null,
          name: newSalt?.name || newSalt?.medicine_salt_name || normalized,
        };
      }
    } catch {
      // fall through — medicine can still be updated without a salt
    }
    return null;
  };

  const handleCreateMedicine = async (e) => {
    e?.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    setLoading(true);
    try {
      // Resolve a typed-but-not-created salt before building the payload. Any
      // leftover typed text (saltInputValue) means the user typed/pasted a salt
      // without committing it — create/attach it, overriding the previous salt.
      let medicine_salt_id = formState.medicine_salt_id;
      let medicine_salt = formState.medicine_salt;
      if (saltInputValue?.trim()) {
        const resolved = await resolveTypedSalt();
        if (resolved?.id) {
          medicine_salt_id = resolved.id;
          medicine_salt = resolved.name;
        }
      }

      let existingBatchesToDestroy = [];

      if (mediDetails?.payload?.medicine_batches?.length > 0) {
        const existingBatchIds = batches
          ?.map((batch) => batch?.id)
          ?.filter(Boolean);

        existingBatchesToDestroy = mediDetails?.payload?.medicine_batches
          .filter((batch) => !existingBatchIds.includes(batch?.id))
          .map((batch) => ({
            ...batch,
            _destroy: "1",
          }));
      }

      const payload = {
        medicine: {
          ...formState,
          medicine_salt_id,
          medicine_salt,
          discount: (formState.flat_price && parseFloat(formState.flat_price) > 0) ? 0 : (formState.discount || 0),
          ...(batches?.length > 0 || existingBatchesToDestroy?.length > 0
            ? {
                medicine_batches_attributes: [
                  ...batches.map((batch) => ({
                    ...batch,
                    cgst: (parseFloat(batch.cgst) || 0).toString(),
                    sgst: (parseFloat(batch.sgst) || 0).toString(),
                    gst: ((parseFloat(batch.cgst) || 0) + (parseFloat(batch.sgst) || 0)).toString(),
                  })),
                  ...existingBatchesToDestroy,
                ],
              }
            : {}),
          // ...(batches.length > 0 && {
          //     medicine_batches_attributes: batches,
          // }),
        },
      };

      const result = await updateMedicine(payload, mediDetails?.payload?.id);
      console.log(result);
      showToast(
        result?.status?.message || result?.status?.status,
        result?.status?.status,
      );
      if (result?.status?.status === "SUCCESS") {
        onClose();

        // ✅ Reset formState
        setFormState({
          name: "",
          company: "",
          srp: "",
          form_type: "",
          flat_price: "",
          auto_purchase_threshold: "",
          medicine_salt_id: "",
          medicine_salt: "",
          discount: "",
          hsn_name: "",
        });

        // ✅ Reset batches
        setBatches([
          {
            batch_no: "",
            expiry_date: "",
            amount: "",
            purchase_cost: "",
            cgst: "",
            sgst: "",
            packing: "",
            stock_left: "",
          },
        ]);
      }
      // if (result?.status?.status === "SUCCESS") {
      //   showToast("Purchase Order Created  Successfully" ,"SUCCESS");
      //   // navigate("/admin/purchase_orders");
      // }
    } catch (error) {
      showToast(error.message, "ERROR");
    } finally {
      setLoading(false);
    }
  };

  // console.log(id, 'id medi if', mediDetails?.payload);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
            position="sticky"
          >
            <Box></Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={medicines_icon}
                alt=""
                sx={{
                  color: "neutral.teal",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Edit Medicines
              </Typography>
            </Box>
            <IconButton
              sx={{ marginBottom: "0rem", borderRadius: "50%" }}
              onClick={onClose}
            >
              <CloseIcon
                size="small"
                sx={{ color: "red", borderRadius: "50%" }}
              />
            </IconButton>
          </Box>

          <Grid container spacing={2}>
            <Grid item sm={2}>
              <TextField
                value={formState?.name}
                fullWidth
                placeholder="Medicine name "
                name="name"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["name"]}
                helperText={errors["name"]}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                value={formState?.company}
                fullWidth
                placeholder="Company "
                name="company"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["company"]}
                helperText={errors["company"]}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                value={formState?.srp}
                fullWidth
                placeholder="SRP "
                name="srp"
                onChange={(e) => handleFormChange(e)}
                sx={autoFocusOffWithOutBorder}
                error={!!errors["srp"]}
                helperText={errors["srp"]}
              />
            </Grid>
            <Grid item sm={2}>
              {/* <TextField value={formState?.form_type} fullWidth placeholder="Form type " name="form_type" onChange={(e) => handleFormChange(e)} sx={autoFocusOffWithOutBorder}
                                error={!!errors['form_type']}
                                helperText={errors['form_type']}
                            /> */}

              <Autocomplete
                clearOnEscape={false}
                clearIcon={null}
                sx={{
                  ...autoFocusOffWithOutBorder,
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    height: "40px",
                    padding: "9px !important",
                    "& input": {
                      padding: "8px",
                      fontSize: "14px",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      display: "none",
                    },
                  },
                }}
                name="form_type"
                options={
                  fieldOptions?.formTypeList?.filter((option) => option) || []
                }
                getOptionLabel={(option) => option?.label || ""}
                value={
                  fieldOptions?.formTypeList?.find(
                    (option) => option.value === formState.form_type,
                  ) || null
                }
                onChange={(e, value) => {
                  setFormState((prev) => ({
                    ...prev,
                    form_type: value?.value || "",
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    form_type: undefined,
                  }));
                }}
                id="form_type"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Form type"
                    error={!!errors.form_type}
                    helperText={errors["form_type"]}
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem {...props} key={option.value}>
                    {option.value}
                  </MenuItem>
                )}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => handleFormChange(e)}
                value={formState.flat_price}
                onBlur={(e) => {
                  const rawValue = e.target.value;
                  const value = Number(rawValue);
                  if (rawValue === "") {
                    // Allow empty value
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "",
                    }));
                    setShowAmount(true);
                  } else if (value <= 0 || isNaN(value)) {
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "Flat Price must be greater than 0",
                    }));
                    setShowAmount(true);
                  } else {
                    setErrors((prev) => ({
                      ...prev,
                      flat_price: "",
                    }));
                    setShowAmount(false);
                  }
                }}
                name="flat_price"
                placeholder="Flat Price"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.flat_price}
                helperText={errors.flat_price}
              />
            </Grid>

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => handleFormChange(e)}
                value={formState?.auto_purchase_threshold}
                name="auto_purchase_threshold"
                placeholder="Auto purchase"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.auto_purchase_threshold}
                helperText={errors.auto_purchase_threshold}
              />
            </Grid>

            <Grid item sm={5}>
              <Box display="flex" alignItems="center" gap="4px">
                <Box sx={{ flexGrow: 1 }}>
                  <CreatableSelect
                    isClearable
                    isLoading={medicineSaltLoading || saltCreating}
                    inputValue={saltInputValue}
                    onInputChange={(value, { action }) => {
                      if (action !== "input-blur" && action !== "menu-close") {
                        setSaltInputValue(value);
                        handleMedicineSaltChange(value);
                      }
                    }}
                    value={
                      formState.medicine_salt
                        ? { value: formState.medicine_salt_id || formState.medicine_salt, label: formState.medicine_salt }
                        : null
                    }
                    onChange={(option) => {
                      setFormState((prev) => ({
                        ...prev,
                        medicine_salt_id: option?.value ?? "",
                        medicine_salt: option?.label ?? "",
                      }));
                      if (option) setSaltInputValue("");
                    }}
                    onCreateOption={handleCreateSalt}
                    options={(fieldOptions?.medicineSaltList || []).map(([id, name]) => ({ value: id, label: name }))}
                    formatCreateLabel={(input) => `Create "${normalizeMedicineSalt(input)}"`}
                    formatOptionLabel={(option, { context }) =>
                      context === "menu" ? (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {option?.__isNew__ ? (
                            <AddCircleIcon
                              sx={{ fontSize: 18, color: "#1b7f3b" }}
                            />
                          ) : (
                            <ScienceOutlinedIcon
                              sx={{ fontSize: 18, color: "#7a869a" }}
                            />
                          )}
                          <span>{option.label}</span>
                        </Box>
                      ) : (
                        option.label
                      )
                    }
                    placeholder="Medicine salt"
                    styles={{
                      container: (base) => ({ ...base, flexGrow: 1 }),
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "15px",
                        minHeight: "40px",
                        fontSize: "14px",
                        fontFamily: "Outfit",
                        backgroundColor: "#fff",
                        borderColor: state.isFocused ? "#2e37a4" : "rgba(46,55,164,0.1)",
                        boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        cursor: "pointer",
                        ...(state.data?.__isNew__
                          ? {
                              color: "#1b7f3b",
                              fontWeight: 600,
                              backgroundColor: state.isFocused
                                ? "#d6f0df"
                                : "#eafaf0",
                            }
                          : {
                              color: "#3a3a3a",
                              backgroundColor: state.isFocused
                                ? "#f0f7ff"
                                : "#fff",
                            }),
                      }),
                      menu: (base) => ({ ...base, zIndex: 9999999, fontFamily: "Outfit", fontSize: "14px" }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </Box>
                <Tooltip
                  title={formState.name?.trim() ? "Get medicine salt suggestion from AI" : "Enter medicine name first"}
                  placement="top"
                >
                  <span>
                    <IconButton
                      onClick={handleAutoFillSalt}
                      disabled={!formState.name?.trim() || autoFillSaltLoading}
                      sx={{
                        color: formState.name?.trim() ? "#2e7d32" : "action.disabled",
                        "&:hover": { backgroundColor: "#e0f4f7", color: "#0097B2" },
                        p: "6px",
                      }}
                    >
                      {autoFillSaltLoading ? (
                        <CircularProgress size={16} sx={{ color: "#2e7d32" }} />
                      ) : (
                        <AutoFixHighIcon fontSize="small" />
                      )}
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </Grid>

            {!(formState.flat_price && parseFloat(formState.flat_price) > 0) && (
              <Grid item sm={2}>
                <TextField
                  fullWidth
                  onChange={(e) => handleFormChange(e)}
                  value={formState.discount}
                  name="discount"
                  placeholder="Discount"
                  type="Discount"
                  required
                  variant="outlined"
                  sx={{ ...autoFocusOffWithOutBorder }}
                  error={!!errors.discount}
                  helperText={errors.discount}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PercentIcon size={18} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={(e) => handleFormChange(e)}
                value={formState.hsn_name}
                name="hsn_name"
                placeholder="HSN code"
                type="number"
                required
                variant="outlined"
                sx={{ ...autoFocusOffWithOutBorder }}
                error={!!errors.hsn_name}
                helperText={errors.hsn_name}
              />
            </Grid>

          </Grid>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%", overflowX: "auto" }}>
              <Table sx={{ minWidth: 1400 }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        borderTopLeftRadius: "20px",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Batches
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Expiry
                    </TableCell>
                    {showAmount && (
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          color: "neutral.black",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        Amount
                      </TableCell>
                    )}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Purchase cost
                    </TableCell>

                    {/* <TableCell
                                            variant="body1_text_bold"
                                            sx={{
                                                color: 'neutral.white',
                                                p: "4px",
                                                textAlign: "center",
                                            }}
                                        >
                                            Form type
                                        </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{ color: "neutral.black", p: "4px", textAlign: "center" }}
                    >
                      CGST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{ color: "neutral.black", p: "4px", textAlign: "center" }}
                    >
                      SGST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Packing
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "4px",
                        textAlign: "center",
                      }}
                    >
                      Stock left
                    </TableCell>

                    <TableCell
                      sx={{
                        p: "4px",
                        textAlign: "center",
                        borderTopRightRadius: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleAddRow}
                        sx={{
                          ...orangeButton,
                          marginLeft: "7px",
                          marginY: "2px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            color: "neutral.white",
                            width: "30px",
                            height: "32px",
                            padding: "0px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {batches?.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{ padding: "0px", margin: "0px" }}
                    >
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="Batch no"
                          value={item?.batch_no}
                          onChange={(e) => {
                            handleChange(index, "batch_no", e.target.value);
                          }}
                          id={`batch_no-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "batch_no")}
                          sx={textfieldTextBlueBr}
                        ></TextField>
                      </TableCell>

                      {/* Quantity Date Field */}
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="expiry"
                          value={item?.expiry_date}
                          onChange={(e) => {
                            handleChange(index, "expiry_date", e.target.value);
                          }}
                          sx={textfieldTextBlueBr}
                          name="expiry_date"
                          fullWidth
                          type="date"
                          id={`expiry_date-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "expiry_date")
                          }
                          inputProps={{
                            min: new Date().toISOString().split("T")[0],
                          }}
                        />
                      </TableCell>
                      {showAmount && (
                        <TableCell
                          variant="body1_text_bold"
                          sx={{
                            width: "14.28%",
                            color: "neutral.white",
                            p: "4px",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            placeholder="Amount"
                            sx={textfieldTextBlueBr}
                            fullWidth
                            value={item?.amount}
                            onChange={(e) => {
                              handleChange(index, "amount", e.target.value);
                            }}
                            id={`amount-${index}`}
                            onKeyDown={(e) => handleKeyDown(e, index, "amount")}
                            name="amount"
                            type="number"
                          />
                        </TableCell>
                      )}

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="Purchase cost"
                          value={item?.purchase_cost}
                          onChange={(e) => {
                            handleChange(
                              index,
                              "purchase_cost",
                              e.target.value,
                            );
                          }}
                          name="purchase_cost"
                          sx={textfieldTextBlueBr}
                          fullWidth
                          type="number"
                          id={`purchase_cost-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "purchase_cost")
                          }
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{ width: "14.28%", color: "neutral.white", p: "4px", textAlign: "center" }}
                      >
                        <TextField
                          placeholder="CGST"
                          value={item?.cgst}
                          onChange={(e) => handleChange(index, "cgst", e.target.value)}
                          sx={textfieldTextBlueBr}
                          fullWidth
                          type="number"
                          disabled={!!item?.batch_in_use}
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{ width: "14.28%", color: "neutral.white", p: "4px", textAlign: "center" }}
                      >
                        <TextField
                          placeholder="SGST"
                          value={item?.sgst}
                          onChange={(e) => handleChange(index, "sgst", e.target.value)}
                          sx={textfieldTextBlueBr}
                          fullWidth
                          type="number"
                          disabled={!!item?.batch_in_use}
                        />
                      </TableCell>

                      {/* <TableCell
                                                variant="body1_text_bold"
                                                sx={{
                                                    borderTopLeftRadius: "20px",
                                                    color: "neutral.white",
                                                    p: "4px",
                                                    textAlign: "center",
                                                    minWidth: "120px",
                                                }}
                                            >


                                                <Autocomplete
                                                    clearOnEscape={false}
                                                    clearIcon={null}
                                                    sx={{
                                                        ...textfieldTextBlueBorder,
                                                        "& .MuiOutlinedInput-root": {
                                                            borderRadius: "10px",
                                                            height: "40px",
                                                            padding: "9px !important",
                                                            "& input": {
                                                                padding: "8px",
                                                                fontSize: "14px",
                                                            },
                                                            "& .MuiAutocomplete-popupIndicator": {
                                                                display: "none", // Hides the dropdown icon
                                                            },
                                                        },
                                                    }}
                                                    options={fieldOptions?.formTypeList || []}
                                                    value={item?.form_type || ""}
                                                    onChange={(e, value) => {
                                                        handleChange(index, "form_type", value || ""); // Ensures the state updates properly
                                                    }}
                                                    id={`form_type-${index}`}
                                                    onKeyDown={(e) => handleKeyDown(e, index, "form_type")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Form type"
                                                        />
                                                    )}
                                                    renderOption={(props, option) => (
                                                        <MenuItem {...props} key={option}>
                                                            {option}
                                                        </MenuItem>
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option === value}
                                                />


                                            </TableCell> */}

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          borderTopLeftRadius: "20px",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                          minWidth: "120px",
                        }}
                      >
                        {/* <Autocomplete
                          clearOnEscape={false}
                          clearIcon={null}
                          sx={{
                            ...textfieldTextBlueBorder,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                              "& .MuiAutocomplete-popupIndicator": {
                                display: "none", // Hides the dropdown icon
                              },
                            },
                          }}
                          options={
                            fieldOptions?.packList?.filter(
                              (option) => option
                            ) || []
                          } // Filter out invalid entries
                          getOptionLabel={(option) => option || ""} // Use the string value directly
                          inputValue={item?.packing || ""} // Handle input display safely
                          // onInputChange={(e, value) => {
                          //   handleChange(index, "packing", value, e); // Update the form state on input change
                          // }}
                          onInputChange={(e, value) => {
                            if (value) {
                              handleChange(index, "packing", value);
                            }
                          }}
                          onChange={(e, value) => {
                            if (value) {
                              // Assuming `value` is a string directly
                              console.log(value);
                              handleChange(index, "packing", value);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select pack"
                              error={!!errors.suppliers}
                            />
                          )}
                          renderOption={(props, option) => (
                            <MenuItem {...props} key={option}>
                              {option}
                            </MenuItem>
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          } // Compare values directly
                        /> */}

                        <Autocomplete
                          clearOnEscape={false}
                          clearIcon={null}
                          sx={{
                            ...textfieldTextBlueBorder,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                              height: "40px",
                              padding: "9px !important",
                              "& input": {
                                padding: "8px",
                                fontSize: "14px",
                              },
                              "& .MuiAutocomplete-popupIndicator": {
                                display: "none",
                              },
                            },
                          }}
                          options={
                            fieldOptions?.packList?.filter(
                              (option) => option,
                            ) || []
                          }
                          value={item?.packing || ""}
                          onChange={(e, value) => {
                            handleChange(index, "packing", value || "");
                          }}
                          id={`packing-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "packing")}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="Packing" />
                          )}
                          renderOption={(props, option) => (
                            <MenuItem {...props} key={option}>
                              {option}
                            </MenuItem>
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                        />
                      </TableCell>

                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "14.28%",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          placeholder="stock left"
                          sx={textfieldTextBlueBr}
                          value={item?.stock_left}
                          onChange={(e) => {
                            handleChange(index, "stock_left", e.target.value);
                          }}
                          id={`stock_left-${index}`}
                          onKeyDown={(e) =>
                            handleKeyDown(e, index, "stock_left")
                          }
                          name="stock_left"
                          fullWidth
                          type="number"
                        />
                      </TableCell>

                      {/* Icon Column */}
                      <TableCell
                        variant="body1_text_bold"
                        sx={{
                          width: "auto",
                          color: "neutral.white",
                          p: "4px",
                          textAlign: "center",
                        }}
                      >
                        <Tooltip
                          title={item?.batch_in_use ? "Batch is in use" : ""}
                          arrow
                        >
                          <span>
                            <IconButton
                              sx={{ marginLeft: "8px", marginBottom: "7px" }}
                              disabled={!!item?.batch_in_use}
                              onClick={() => handleDeleteRow(index)}
                            >
                              <CloseIcon
                                sx={{
                                  ...xBtn,
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "50%",
                                  backgroundColor: item?.batch_in_use
                                    ? "#ccc"
                                    : "neutral.red",
                                }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          container
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ zIndex: "10" }}
          lg={12}
          marginBottom={"5px"}
        >
          <Grid item></Grid>

          <Grid item>
            <Button
              onClick={handleCreateMedicine}
              className="btn draw-border"
              variant="contained"
              id="submit"
              sx={{
                ...primaryBtnTeal,
                width: "195px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              //   disabled={isLoading}
            >
              Update Medicine
            </Button>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default EditMedicineBatchShort;
